import angular from 'angular';
import uiRouter from 'angular-ui-router';
import resetPasswordService from './reset-password.service';
import resetPassword from './reset-password.component';

export default
  angular.module('components.auth.resetPassword', [
    uiRouter
  ])
    .component('resetPassword', resetPassword)
    .service('ResetPasswordService', resetPasswordService)
    .config(($stateProvider) => {
      'ngInject';

      $stateProvider
        .state('resetPassword', {
          parent: 'auth',
          url: '/reset-password',
          params: {
            userName: null
          },
          component: 'resetPassword',
          resolve: {
            layout: () => 'column',
            flex: () => '100',
            credentials: $stateParams => ({
              UserName: $stateParams.userName
            })
          }
        });
    })
    .name;



// WEBPACK FOOTER //
// ./components/auth/reset-password/reset-password.module.js